import { useMemo } from 'react';

import { Assignee } from '../../redux/Slices/ScheduleTestSlice/types';

const ScheduleTestAssigneesTable = ({
  assignees,
  selectedTag,
  onToggleAssignee,
  onSelectAll,
  studentMap
}: any) => {
  //  DO NOT FILTER BY selected
  const tableData = assignees;

  const selectedStudents = useMemo(() => {
    return assignees.filter((a: Assignee) => a.selected);
  }, [assignees]);

  return (
    <div className='w-full overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm'>
      <div className='p-8'>
        <div className='flex items-center justify-between'>
          <h3 className='mb-6 text-xl font-semibold text-gray-900'>
            Assignees <span className='text-[red]'>*</span>
          </h3>
          <div className='mb-4 text-lg font-semibold text-blue-700'>
            Selected: {selectedStudents?.length}
          </div>
        </div>

        <div className='overflow-x-auto'>
          <table className='w-full'>
            <thead>
              <tr className='border-b border-blue-100 bg-blue-50'>
                <th className='px-6 py-4 text-left'>
                  <input
                    type='checkbox'
                    checked={
                      assignees.length > 0 &&
                      assignees.every((a: { selected: any }) => a.selected)
                    }
                    onChange={onSelectAll}
                    className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
                  />
                </th>

                <th className='px-6 py-4 text-left text-sm font-medium text-blue-600'>
                  Name
                </th>
                <th className='px-6 py-4 text-left text-sm font-medium text-blue-600'>
                  Year Of Passing
                </th>
                <th className='px-6 py-4 text-left text-sm font-medium text-blue-600'>
                  Mail Id
                </th>
                <th className='px-6 py-4 text-left text-sm font-medium text-blue-600'>
                  Mobile Number
                </th>
                <th className='px-6 py-4 text-left text-sm font-medium text-blue-600'>
                  Branch
                </th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((assignee: Assignee, index: number) => (
                <tr
                  key={assignee?.emailId}
                  className={`border-b border-gray-100 ${index % 2 === 0 ? 'bg-white' : 'bg-blue-50/30'} transition-colors hover:bg-blue-50/50`}
                >
                  <td className='px-6 py-4'>
                    <input
                      type='checkbox'
                      checked={assignee.selected}
                      onChange={() => onToggleAssignee(assignee.studentId)}
                      className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
                    />
                  </td>
                  <td className='px-6 py-4 text-sm text-gray-900'>
                    {assignee?.studentName
                      ? assignee.studentName
                      : 'Loading...'}
                  </td>

                  <td className='px-6 py-4 text-sm text-gray-900'>
                    {assignee?.yearOfPassing ?? '-'}
                  </td>
                  <td className='px-6 py-4 text-sm text-gray-900'>
                    {assignee?.emailId ?? '-'}
                  </td>
                  <td className='px-6 py-4 text-sm text-gray-900'>
                    {assignee?.mobileNumber ?? '-'}
                  </td>
                  <td className='px-6 py-4 text-sm text-gray-900'>
                    {assignee?.branch ?? '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ScheduleTestAssigneesTable;
